import { AuthStep, AuthStepItem, UrlPart } from '../types';
import { Params } from '../../shared/types';

function getUrlPartDefaultValue(urlPart: UrlPart): string {
  switch (urlPart.type) {
    case 'Static':
      return urlPart.value;
    case 'Select':
      return urlPart.options.length > 0 ? urlPart.options[0] : '';
    case 'Domain':
    case 'Path':
    default:
      return '';
  }
}

function getItemDefaultValue(
  item: AuthStepItem
): string | Array<string> | null {
  if (!('name' in item)) {
    return null;
  }

  switch (item.type) {
    case 'Url':
      return item.parts.map(getUrlPartDefaultValue);
    case 'Select':
      return item.options.length > 0 ? item.options[0].value : '';
    case 'Password':
    case 'Text':
    case 'Email':
    default:
      return '';
  }
}

export function getParamDefaultsFromSteps(steps: Array<AuthStep>): Params {
  const params: Params = {};

  steps.forEach((step) => {
    step.items.forEach(({ item }) => {
      const defaultValue = getItemDefaultValue(item);

      if (defaultValue !== null && 'name' in item) {
        params[item.name] = defaultValue;
      }
    });
  });

  return params;
}
